import {InputAdornment} from "@mui/material";
import React from "react";
import {IconCalendar} from "../bounce-ui";
import {Colors} from "../../ui";

export const datePickerStyle = (isMobile: boolean) => {
  return {
    textField: {
      InputProps: {
        sx: {
          borderRadius: "8px",
        },
        ...(isMobile && {
          endAdornment: (
            <InputAdornment position="end">
              <IconCalendar color={Colors.grey._700} />
            </InputAdornment>
          ),
        }),
      },
    },
  };
};
